function readScaleFromTransform(element: Element): number | null {
  const transform = window.getComputedStyle(element).transform;
  if (!transform || transform === "none") {
    return null;
  }

  const scaleX = new DOMMatrixReadOnly(transform).a;
  return Number.isFinite(scaleX) && scaleX > 0 ? scaleX : null;
}

export function readEmailBuilderMobileCanvasLayoutScale(node: Element | null | undefined): number {
  if (node === null || node === undefined) {
    return 1;
  }

  const frame = node.closest(".email-builder-canvas-frame--mobile-scaled");
  if (frame === null) {
    return 1;
  }

  const transformScale = readScaleFromTransform(frame);
  if (transformScale !== null && transformScale !== 1) {
    return transformScale;
  }

  const scaleHost =
    frame.closest<HTMLElement>(".email-builder-canvas--mobile-layout") ?? frame;
  const raw = window
    .getComputedStyle(scaleHost)
    .getPropertyValue("--email-builder-mobile-canvas-scale")
    .trim();
  const parsed = Number.parseFloat(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

export function emailBuilderVisualLengthToLayoutLength(
  visualLength: number,
  layoutScale: number,
): number {
  const safeScale = layoutScale > 0 ? layoutScale : 1;
  return Math.max(1, Math.round(visualLength / safeScale));
}
